import { render, staticRenderFns } from "./instructions-files-modal.vue?vue&type=template&id=45ef546d&scoped=true&"
import script from "./instructions-files-modal.vue?vue&type=script&lang=ts&"
export * from "./instructions-files-modal.vue?vue&type=script&lang=ts&"
import style0 from "./instructions-files-modal.vue?vue&type=style&index=0&id=45ef546d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ef546d",
  null
  
)

export default component.exports